import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';

import TestResultsMainHeader from '../../../components/TestResultsMainHeader';
import ProductCheckoutPageGenerator from '../../components/ProductCheckoutPageGenerator';

import { getProductCheckoutPage } from '../../actions/productCheckoutPage';

import './index.scss';

const ProductCheckoutPage = ({
  dispatch,
  data,
  error,
  loading,
  lang,
  changeLanguage,
}) => {
  const { testCode } = useParams();

  useEffect(() => {
    dispatch(getProductCheckoutPage(testCode, lang));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, testCode, lang]);

  if (loading) return <div className='product-checkout-page__loader'></div>;

  return (
    <div className='product-checkout-page'>
      <TestResultsMainHeader
        availableLanguages={['en', 'de', 'fr']}
        defaultLanguage={lang}
        onChangeLanguage={changeLanguage}
        dispatch={dispatch}
        className='product-checkout-page__header'
        logoClassName='product-checkout-page__logo'
      />

      {data && !error && (
        <div className='product-checkout-page__content'>
          <ProductCheckoutPageGenerator data={data} />
        </div>
      )}
    </div>
  );
};

ProductCheckoutPage.propTypes = {
  dispatch: PropTypes.func,
  data: PropTypes.object,
  error: PropTypes.object,
  loading: PropTypes.bool,
  lang: PropTypes.string,
  changeLanguage: PropTypes.func,
};

const mapStateToProps = (state) => ({
  data: state.productCheckoutPage.get('data'),
  error: state.productCheckoutPage.get('error'),
  loading: state.productCheckoutPage.get('loading'),
});

export default connect(mapStateToProps)(ProductCheckoutPage);
